import { TableIconButton } from './TableIconAction';
import { ExcelIcon, PdfIcon } from './ui';
import { t } from '../i18n';

export function ExportIconButtons({
  disabled,
  onExcel,
  onPdf,
  excelLabel,
  pdfLabel,
}: {
  disabled: boolean;
  onExcel: () => void;
  onPdf: () => void;
  excelLabel?: string;
  pdfLabel?: string;
}) {
  return (
    <div className="inline-flex items-center gap-0.5">
      <TableIconButton
        label={excelLabel ?? t().reports.exportExcel}
        disabled={disabled}
        onClick={onExcel}
      >
        <ExcelIcon className="h-4 w-4" />
      </TableIconButton>
      <TableIconButton
        label={pdfLabel ?? t().reports.exportPdf}
        disabled={disabled}
        onClick={onPdf}
      >
        <PdfIcon className="h-4 w-4" />
      </TableIconButton>
    </div>
  );
}
